import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowseObligorComponent } from './browse-obligor/browse-obligor.component';
import { CurrentissuesComponent } from './currentissues/currentissues.component';
import { RegistrationComponent } from './registration/registration.component';
import { AuditedFinancialStatementsComponent } from './audited-financial-statements/audited-financial-statements.component';
import { AnnualFinancialInformationComponent } from './Annualfinancial/annual-financial-information.component';
import { BudgetsComponent } from './Budgets/budgets.component';
import { InterimfinancialsComponent } from './Interim/interimfinancials.component';
import { FailuretoProvideComponent } from './Failure/failureto-provide.component';
import { OtherFinancialOperatingComponent } from './OtherFinancial/other-financial-operating.component';
import { OtherEventbasedDisclosuresComponent } from './OtherEvent/other-eventbased-disclosures.component';
import { RatingChangeComponent } from './RatingChange/rating-change.component';
import { UnscheduledComponent } from './Unscheduled/unscheduled.component';
import { BondCallsComponent } from './BondCalls/bond-calls.component';
import { QComponent } from './q/q.component';
import { IssuesNoLongerComponent } from './IssuesNoLonger/issues-no-longer.component';
import { AskAQuestionComponent } from './AskAQuestion/ask-aquestion.component';
import { DachomepageComponent } from './Dachomepage/dachomepage.component';
import { DmcaComponent } from './dmca/dmca.component';
import { DACForInvestorsComponent } from './DACForInvestors/dacfor-investors.component';
import { IssuersandObligorsComponent } from './IssuersandObligors/issuersand-obligors.component';
import { LegalInformationComponent } from './LegalInformation/legal-information.component';
import { AccessingwebcastsComponent } from './Accessingwebcasts/accessingwebcasts.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { PostIssuanceTaxComplianceComponent } from './PostIssuanceTaxCompliance/post-issuance-tax-compliance.component';
import { HelpComponent } from './help/help.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { AboutUsSecuritiesComponent } from './aboutUsSecurities/about-us-securities.component';
import { InvestorBrowseFilingTypesComponent } from './investor-browse-filing-types/investor-browse-filing-types.component';
import { InvestorBrowseBorrowingDocumentsComponent } from './investor-browse-borrowing-documents/investor-browse-borrowing-documents.component';

const routes: Routes = [
  { path: '', redirectTo: 'Dachomepage', pathMatch: 'full' },
  { path: 'Dachomepage', component: DachomepageComponent },
  { path: 'browse-obligor', component: BrowseObligorComponent },
  { path: 'currentissues', component: CurrentissuesComponent },
  { path: 'audited-financial-statements', component: AuditedFinancialStatementsComponent },
  { path: 'q', component: QComponent },
  { path: 'issues-no-longer', component: IssuesNoLongerComponent },
  { path: 'Annualfinancial', component: AnnualFinancialInformationComponent },
  { path: 'Budgets', component: BudgetsComponent },
  { path: 'Interim', component: InterimfinancialsComponent },
  { path: 'Failure', component: FailuretoProvideComponent },
  { path: 'OtherFinancial', component: OtherFinancialOperatingComponent },
  { path: 'OtherEvent', component: OtherEventbasedDisclosuresComponent },
  { path: 'RatingChange', component: RatingChangeComponent },
  { path: 'Unscheduled', component: UnscheduledComponent },
  { path: 'BondCalls', component: BondCallsComponent },
  { path: 'q', component: QComponent },
  { path: 'issues-no-longer', component: IssuesNoLongerComponent },
  { path: 'ask-aquestion', component: AskAQuestionComponent },
  { path: 'Dachomepage', component: DachomepageComponent },
  { path: 'registration', component: RegistrationComponent },
  { path: 'dmca', component: DmcaComponent },
  { path: 'DACForInvestors', component: DACForInvestorsComponent },
  { path: 'IssuersandObligors', component: IssuersandObligorsComponent },
  { path: 'legal-information', component: LegalInformationComponent },
  { path: 'Accessingwebcasts', component: AccessingwebcastsComponent },
  { path: 'aboutus', component: AboutusComponent },
  { path: 'aboutUsSecurities', component: AboutUsSecuritiesComponent },
  { path: 'PostIssuanceTaxComplianceComponent', component: PostIssuanceTaxComplianceComponent },
  { path: 'help', component: HelpComponent },
  { path: 'sitemap', component: SitemapComponent },
  { path: 'investor-browse-filing-types', component: InvestorBrowseFilingTypesComponent },
  { path: 'investor-browse-borrowing-documents', component: InvestorBrowseBorrowingDocumentsComponent },
];



@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
